import { render } from "./Holds.vue?vue&type=template&id=23998340&scoped=true&ts=true&lang=pug"
import script from "./Holds.vue?vue&type=script&lang=ts&setup=true"
export * from "./Holds.vue?vue&type=script&lang=ts&setup=true"

import "./Holds.vue?vue&type=style&index=0&id=23998340&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23998340"]])

export default __exports__